/**
 * Gets a cookie from the browser.
 * 
 * @param {String} name - the name of the cookie to catch
 * 
 * @returns {String}
 */
export const getCookie = (name) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export const setCookie = (name, value, expires, path) => {
    document.cookie = `${name}=${value}; ${expires ? `expires=${new Date(moment().add(expires, 'days').toDate())}` : ''}; path=${path ? path : '/'}`;
}

export const removeKeysFromLocalStorage = keys =>
    keys.forEach((key) => localStorage.removeItem(key));

export const removeKeysFromSessionStorage = keys =>
    keys.forEach((key) => sessionStorage.removeItem(key));

export const eventBuilder = (...eventsNames) =>
    eventsNames.reduce((acc, v) => ({
        ...acc,
        [v]: new Event(v),
    }), {});

/**
 * @function removeKeysFromLocalAndSession
 * 
 * @param {String[]} localKeys 
 * @param {String[]} sessionKeys
 * 
 * @returns {undefined}
 */
export const removeKeysFromLocalAndSession = (localKeys, sessionKeys) => {
    removeKeysFromLocalStorage(localKeys);
    removeKeysFromSessionStorage(sessionKeys);
};

window.getCookie = getCookie;
window.setCookie = setCookie;

export const isFallbackMode = () => {
    if (getCookie('fallback-mode') === 'true')
        return true;

    return false;
};

/**
 * Returns the current active hotel uuid.
 * 
 * @function getActiveHotelUuid
 * 
 * @returns {String}
 */
export const getActiveHotelUuid = () =>
    window.HOTEL_INFO_DATA ? window.HOTEL_INFO_DATA.active_hotel_uuid : '';


export const JSONParse = (string) => new Promise((resolve, reject) => {
    let data;
    try {
        data = JSON.parse(string);
        resolve(data);
    } catch (e) {
        reject(e);
    }
})

export const validateAndParseData = (string) => new Promise((resolve, reject) => {
    if (string && string !== '' && string !== 0)
        JSONParse(string).then(resolve).catch(reject);
    else
        reject();
})
